import React from 'react';
import { useNavigate } from 'react-router-dom';

function Dashboard({ registrationType, setRegistrationType, resetRegistrationData, t, trainerSession, onLogout }) {
  const navigate = useNavigate();

  const handleRegistrationTypeSelect = (type) => {
    setRegistrationType(type);
    navigate('/persona-selection');
  };

  // Check if user is returning to dashboard from registration process
  const isReturningFromRegistration = document.referrer && !document.referrer.includes('/');

  // If returning from a registration page and there's registration data, show cancel option
  const showCancelOption = isReturningFromRegistration || registrationType !== '';

  const handleCancelRegistration = () => {
    if (window.confirm(t('cancelConfirmation') || 'Are you sure you want to cancel the registration? All data will be lost.')) {
      resetRegistrationData();
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <h1 className="text-3xl font-bold text-center mb-8 text-blue-600">Client Registration</h1>
        <div className="space-y-6">
          <p className="text-center text-gray-600 mb-6">Select registration type to begin:</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <button
              onClick={() => handleRegistrationTypeSelect('training')}
              className="bg-[#d0a949] hover:bg-[#a6873a] text-white py-6 px-4 rounded-lg shadow transition duration-200 flex flex-col items-center justify-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span className="text-lg font-medium">Personal Training</span>
            </button>
            
            <button
              onClick={() => handleRegistrationTypeSelect('fitness')}
              className="bg-green-600 hover:bg-green-700 text-white py-6 px-4 rounded-lg shadow transition duration-200 flex flex-col items-center justify-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
              </svg>
              <span className="text-lg font-medium">Fitness</span>
            </button>
          </div>
          
          {showCancelOption && (
            <div className="mt-6 text-center">
              <button
                onClick={handleCancelRegistration}
                className="text-red-600 hover:text-red-800 font-medium transition duration-200"
              >
                {t('cancelRegistration') || 'Cancel Registration'}
              </button>
              <p className="text-xs text-gray-500 mt-1">{t('cancelWarning') || 'All entered data will be removed'}</p>
            </div>
          )}
        </div>

        <div className="flex items-center justify-between mt-6 text-sm">
          <p className="text-gray-600">
            Logged in Trainer: <span className="font-semibold"> {trainerSession?.username}</span>
          </p>
          <button
            onClick={onLogout}
            className="text-red-600 hover:text-red-800 font-medium transition duration-200"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
